import { ConnectionFlow } from '@oneclick/features/connect-cluster/_components/ConnectionFlow';

import { ConnectionChoice } from '../../_constants';

type Step2Props = {
  initialChoice?: ConnectionChoice;
  onBack?: () => void;
  cardTotalSteps?: number;
};

export const Step2 = ({
  initialChoice = ConnectionChoice.cloudConnect,
  onBack,
  cardTotalSteps = 3,
}: Step2Props) => (
  <ConnectionFlow
    layout="card"
    initialChoice={initialChoice}
    onBack={onBack}
    cardTotalSteps={cardTotalSteps}
  />
);
